import React from 'react'
import { Row } from 'react-bootstrap'
import ReleatedCarousel from '../../carousel/RelatedProducts/RelatedCarousel'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import ContentCover from '../../content/ContentCover/ContentCover'
import SectionHeading from '../../section-heading/SectionHeading'
import { productsHeading } from '../FeaturedProducts/featured-products.module.scss'

const FeaturedProductsCarousel = ({
  title,
  featuredProducts,
  showAddToCart = false,
}) => {
  const bg = {
    backgroundColor: 'rgba(55,86,147,0.1)',
  }

  return (
    <ContentCover bg={bg}>
      <ContentContainer>
        <SectionHeading title={title} className={productsHeading} />
        <Row>
          <ReleatedCarousel
            products={featuredProducts.products}
            showAddToCart={showAddToCart}
          />
        </Row>
      </ContentContainer>
    </ContentCover>
  )
}

export default FeaturedProductsCarousel
